export const collectionMicroDataAboutValues = {
  bluelight: [
    {
      '@type': 'Thing',
      name: 'Lunettes',
      sameAs: 'https://www.wikidata.org/wiki/Q37501',
    },
    {
      '@type': 'Thing',
      name: 'Lumière bleue',
      sameAs: 'https://www.wikidata.org/wiki/Q25112120',
    },
  ],
  reading: [
    [
      {
        '@type': 'Thing',
        name: 'Lunettes',
        sameAs: 'https://www.wikidata.org/wiki/Q37501',
      },
      {
        '@type': 'Thing',
        name: 'Lunette',
        sameAs: 'https://www.wikidata.org/wiki/Q1294484',
      },
      {
        '@type': 'Thing',
        name: 'Opticien-lunetier',
        sameAs: 'https://www.wikidata.org/wiki/Q1996635',
      },
    ],
  ],
};

export const collectionMicroDataMentionsValues = {
  bluelight: [
    {
      '@type': 'Thing',
      name: 'Lunettes de protection',
      sameAs: 'https://www.wikidata.org/wiki/Q72797',
    },
    {
      '@type': 'Thing',
      name: 'Effets de la lumière bleue sur le sommeil et les rythmes circadiens',
      sameAs: 'https://www.wikidata.org/wiki/Q60964582',
    },
    {
      '@type': 'Thing',
      name: 'Lunettes de soleil',
      sameAs: 'https://www.wikidata.org/wiki/Q217541',
    },
    {
      '@type': 'Thing',
      name: 'Luminette',
      sameAs: 'https://www.wikidata.org/wiki/Q3267309',
    },
    {
      '@type': 'Thing',
      name: 'Traitement antireflet',
      sameAs: 'https://www.wikidata.org/wiki/Q583040',
    },
  ],
  reading: [
    {
      '@type': 'Thing',
      name: 'Lunettes de soleil',
      sameAs: 'https://www.wikidata.org/wiki/Q217541',
    },
    {
      '@type': 'Thing',
      name: 'Myopie',
      sameAs: 'https://www.wikidata.org/wiki/Q168403',
    },
    {
      '@type': 'Thing',
      name: 'Presbytie',
      sameAs: 'https://www.wikidata.org/wiki/Q319595',
    },
    {
      '@type': 'Thing',
      name: 'Verre',
      sameAs: 'https://www.wikidata.org/wiki/Q11469',
    },
    {
      '@type': 'Thing',
      name: 'Verre correcteur',
      sameAs: 'https://www.wikidata.org/wiki/Q2143661',
    },
    {
      '@type': 'Thing',
      name: 'Loupe',
      sameAs: 'https://www.wikidata.org/wiki/Q166849',
    },
  ],
};
